module.exports = __webpack_public_path__ + "Framet-fffb4676.webp";